function AdminPropertyListSection({ dashboardError, handleDeleteProperty, handleEditProperty, saveMessage, sortedProperties }) {
  return (
    <section className="grid gap-6">
      <div className="rounded-[28px] border border-[#1832281a] bg-[rgba(249,245,238,0.9)] p-6 shadow-[0_22px_60px_rgba(24,50,40,0.08)]">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div>
            <p className="mb-2 text-xs uppercase tracking-[0.14em] text-[#7c6b52]">Portefølje</p>
            <h2 className="font-serif text-3xl font-semibold text-[#163127]">Administrer eiendommer</h2>
          </div>
          <span className="rounded-full bg-[rgba(255,255,255,0.8)] px-4 py-2 text-sm font-semibold text-[#355046]">
            {sortedProperties.length} objekter i databasen
          </span>
        </div>
        {saveMessage ? <p className="mt-4 rounded-2xl bg-[rgba(215,239,224,0.8)] px-4 py-3 text-[#1d4c3b]">{saveMessage}</p> : null}
        {dashboardError ? <p className="mt-4 rounded-2xl bg-[rgba(255,245,242,0.9)] px-4 py-3 text-[#8a2e20]">{dashboardError}</p> : null}
        <div className="mt-6 grid gap-4">
          {sortedProperties.map((property) => (
            <article className="rounded-[22px] border border-[#18322812] bg-[rgba(255,255,255,0.6)] p-4" key={property.slug}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <p className="mb-1 text-xs uppercase tracking-[0.14em] text-[#7c6b52]">
                    {property.availability === 'opptatt' ? 'Opptatt' : 'Ledig'}
                  </p>
                  <h3 className="text-xl font-semibold text-[#163127]">{property.name}</h3>
                  <p className="m-0 text-sm text-[#355046]">{property.address}</p>
                </div>
                <div className="flex flex-wrap gap-2">
                  <button
                    className="rounded-full border border-[#1832281f] bg-white px-4 py-2 text-sm font-semibold text-[#355046]"
                    onClick={() => handleEditProperty(property)}
                    type="button"
                  >
                    Rediger
                  </button>
                  <button
                    className="rounded-full border border-[#9c3d2d33] bg-[rgba(255,245,242,0.9)] px-4 py-2 text-sm font-semibold text-[#8a2e20]"
                    onClick={() => handleDeleteProperty(property.slug)}
                    type="button"
                  >
                    Slett
                  </button>
                </div>
              </div>
              <div className="mt-4 grid gap-3 md:grid-cols-4">
                <div className="rounded-2xl bg-[rgba(249,245,238,0.8)] p-3 text-sm text-[#355046]">
                  <strong className="block text-[#163127]">Type</strong>
                  {property.type}
                </div>
                <div className="rounded-2xl bg-[rgba(249,245,238,0.8)] p-3 text-sm text-[#355046]">
                  <strong className="block text-[#163127]">Størrelse</strong>
                  {property.size}
                </div>
                <div className="rounded-2xl bg-[rgba(249,245,238,0.8)] p-3 text-sm text-[#355046]">
                  <strong className="block text-[#163127]">Ledig fra</strong>
                  {property.availableFrom || '–'}
                </div>
                <div className="rounded-2xl bg-[rgba(249,245,238,0.8)] p-3 text-sm text-[#355046]">
                  <strong className="block text-[#163127]">Kategori</strong>
                  {property.availability}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AdminPropertyListSection;